import React from 'react'

export const FileLabel = ({ children }) => {
  return <span className="file-label">{children}</span>
}
